<template>
    <div
        v-if="isEdit"
        class="warn-tips"
    >
        <span>温馨提示：</span>
        <p
            v-for="(tip, tipIndex) in visibleTips"
            :key="tipIndex"
        >
            {{ tip }}
        </p>
        <mc-button
            v-if="tips.length > 5"
            class="toggle-btn"
            type="text"
            @click="toggleExpand"
        >
            {{ isExpanded ? '收起' : '... 展开' }}
        </mc-button>
    </div>
</template>

<script>
import {
    ref,
    computed,
} from '@vue/composition-api';

export default {
    props: {
        isEdit: {
            type: Boolean,
            required: true,
        },
        tips: {
            type: Array,
            required: true,
        },
    },
    setup(props, { emit }) {
        const isExpanded = ref(false);
        const visibleTips = computed(() => (isExpanded.value ? props.tips : props.tips.slice(0, 5)));
        const toggleExpand = () => {
            isExpanded.value = !isExpanded.value;
        };

        return {
            isExpanded,
            visibleTips,
            toggleExpand,
        };
    },
};
</script>

<style lang="scss" scoped>
.warn-tips {
    font-size: 13px;
    color: #444;
    margin-bottom: 4px;

    span {
        color: #FF6000;
    }
    p {
        margin: 0;
        line-height: 22px;
    }
    .toggle-btn {
        font-size: 12px;
        color: #007BFF;
        background: none;
        border: none;
        cursor: pointer;
    }
}
/deep/ .mtd-btn-text {
    font-size: 13px;
    color: #FF6000;
    padding: 0;
}
</style>
